import { Component, OnInit } from '@angular/core';
import { environment } from '../../../environments/environment';
import { Router } from '@angular/router';
import { SharedService } from '../../../app/core/services/shared.service';

@Component({
  selector: 'app-collaboration-school-view-tutorial',
  templateUrl: './collaboration-school-view-tutorial.component.html',
  styleUrls: ['./collaboration-school-view-tutorial.component.scss']
})
export class CollaborationSchoolViewTutorialComponent implements OnInit {


  constructor(private router : Router, public sharedService : SharedService) {  }

  ngOnInit(): void {
  }

   appsUrl = environment.CMS_APPS_URL;
   signUrl = environment.WEB_URL;
   searchText = '';

   searchPodcasts() {}

   viewTutorial(group, tutorial){
    this.router.navigateByUrl('/en/collaboration-school/' + group.groupId + '/' + tutorial.type);
   }

   tutprial = {
    "title": "Team collaboration that works",
    "description": "Communicate efficiently with one-on-one chats, group conversations, video calls, screen sharing, file sharing, and a built-in calendar. Amy Team Collaboration empowers teams to stay productive and manage tasks effectively.",
    "table_of_contents": [
      "Introduction",
      "Zero Friction",
      "AI Powered",
      "View Code & Digest",
      "Dynamic Data",
      "Share & Collaborate",
      "Seamlessly with Locofy Builder",
      "Direct Export & Deploy",
      "Conclusion"
    ],
    "up_next": {
      "title": "TEAM COLLABORATION",
      "description": "Communicate efficiently with one-on-one chats."
    },
    "introduction": {
      "text": "Figma has become a household name in the UI/UX community. Being a truly browser-first product (not just storage in the cloud - no installation, no patching, no updates) and with highly collaborative features that no other player could think of or execute, Figma emerged as the clear market leader.\n\nYou can design anything on Figma – from a cool logo to native apps and much more. But design is just the beginning of building a world-class product. You need to bring your product to life by actually building it – Writing the damn code!\n\nThat’s where Locofy.ai comes in. While Figma is enough to get the ball rolling, Locofy.ai even takes it further by enabling anyone with a Figma design to get high-quality, pixel-perfect code. Hence, accelerating the building process – with minimal time and a shallow learning curve, builders can now quickly and easily go from Figma to code.\n\nValidating an idea? Revamping your UI? The Locofy plugin puts Figma on steroids by taking your idea from design to websites and apps."
    }
  }  
}
